<template>
    <div id="publication-page">
        <div class="nav-space"></div>
        <h1>LAM, Man Ho (Donald) 林文昊</h1>
        <h2>mhlam@link.cuhk.edu.hk</h2>
        <PublicationList />
        <PreprintList />
    </div>
</template>

<script>
import PublicationList from '../components/publication/PublicationList.vue'
import PreprintList from '../components/publication/PreprintList.vue'

export default {
    name: 'PublicationPage',
    components: { PublicationList, PreprintList },
    mounted(){
        this.$nextTick(() => {
            if(!this.$route.query.location) return
            let location = typeof this.$route.query.location === 'number' ? this.$route.query.location : document.getElementById(this.$route.query.location).offsetTop
            window.scrollTo({
                top: location - 50,
                behavior: 'smooth'
            })
        })
    }
}
</script>

<style scoped>
#publication-page{
    text-align: center;
    min-width: 1000px;
}
.nav-space{
    height: 50px;
    background-color: #181e2def;
}
h1{
    font-family: 'Times New Roman', Times, serif;
    font-weight: 500;
    font-size: 40px;
    line-height: 1.5;
    margin-top: 20px;
}
h2{
    font-size: 20px;
    line-height: 1.5;
}
</style>